import React from "react";
import {Progress} from "reactstrap";
import "./headerProgressBar.sass";

export interface IHeaderProgressBarProps {
  progressBarLoading?: boolean;
}

const HeaderProgressBar: React.FC<IHeaderProgressBarProps> = (props) => {
  return (
    <Progress
      data-testid={"progressBar"}
      color="info"
      animated
      className={`${props.progressBarLoading ? "visible" : "invisible"}`}
      value={props.progressBarLoading ? 95 : 0}
    />
  );
};

export default HeaderProgressBar;
